import { useEffect } from "react";

const SITE_URL = "https://nightly.co";
const DEFAULT_ROBOTS = "index, follow";

const upsertTag = (selector, tagName, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement(tagName);
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const Seo = ({ title, description, path = "/", robots = DEFAULT_ROBOTS }) => {
  useEffect(() => {
    const normalizedPath = path === "/" ? "/" : path.replace(/\/$/, "");
    const canonicalUrl = `${SITE_URL}${normalizedPath}`;

    document.title = title;

    upsertTag('meta[name="description"]', "meta", {
      name: "description",
      content: description,
    });
    upsertTag('meta[name="robots"]', "meta", {
      name: "robots",
      content: robots,
    });
    upsertTag('link[rel="canonical"]', "link", {
      rel: "canonical",
      href: canonicalUrl,
    });
    upsertTag('meta[property="og:title"]', "meta", {
      property: "og:title",
      content: title,
    });
    upsertTag('meta[property="og:description"]', "meta", {
      property: "og:description",
      content: description,
    });
    upsertTag('meta[property="og:url"]', "meta", {
      property: "og:url",
      content: canonicalUrl,
    });
  }, [description, path, robots, title]);

  return null;
};

export default Seo;
